import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Attaches the signed-in user's Firebase ID token to calls to the Django API,
 * so Django can verify WHO is calling (firebase_admin.auth.verify_id_token)
 * and check the `admin` claim on privileged endpoints like /broadcast/send/.
 * Anonymous visitors (e.g. newsletter subscribe) simply send no header.
 */
export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.djangoApiUrl || !req.url.startsWith(environment.djangoApiUrl)) {
    return next(req);
  }
  const user = inject(Auth).currentUser;
  if (!user) return next(req);

  return from(user.getIdToken()).pipe(
    switchMap(token => next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }))),
  );
};
